import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "authConfig";
import { AuthProvider } from "context/authContext.js";
import { AccessTokenProvider } from "context/tokenConfig.js";
import { RoleTokenProvider } from "context/roleContext";
import { ClientProvider } from "context/clientContext";
import HasCheckedProvider from "context/hasCheckedContext";
import AdminLayout from "layouts/Admin.js";

import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.3.0";
import "assets/demo/demo.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

async function renderApp() {
  try {
    await msalInstance.initialize();
    console.log("MSAL instance initialized");

    await msalInstance.handleRedirectPromise();
    console.log("MSAL redirect handled (if applicable)");

    root.render(
      <HasCheckedProvider>
        <ClientProvider>
          <RoleTokenProvider>
            <AccessTokenProvider>
              <AuthProvider>
                <MsalProvider instance={msalInstance}>
                  <BrowserRouter>
                    <Routes>
                      <Route path="/admin/*" element={<AdminLayout />} />
                      <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
                    </Routes>
                  </BrowserRouter>
                </MsalProvider>
              </AuthProvider>
            </AccessTokenProvider>
          </RoleTokenProvider>
        </ClientProvider>
      </HasCheckedProvider>
    );
  } catch (error) {
    console.error("❌ MSAL initialization or redirect error:", error);
  }
}

renderApp();
